module.exports = __webpack_public_path__ + "img/customer_medium@2x.7f8216ca.jpg";